<script>
import AccountRegisterComponent from '../features/AccountRegisterComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'AccountRegisterView',
  components: {
        'brand-logo': BrandLogo,},
  mixins: [AccountRegisterComponent],
};
</script>

<template>
  <div class="public-page">
    <div class="public-page__background">
      <!-- Left Branding Panel -->
      <div class="public-page__branding">
        <div class="public-page__branding-content">
          <router-link
            to="/"
            class="public-page__logo-link"
          >
            <brand-logo
              variant="light"
              size="lg"
              stacked
            />
          </router-link>
          <div class="public-page__branding-text">
            <h1>Únete a AppMisionate</h1>
            <p>Crea tu cuenta y accede a cursos, simuladores y recursos educativos diseñados para tu desarrollo profesional.</p>
          </div>
        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="public-page__form-panel">
        <div class="public-page__card">
          <!-- Card Header -->
          <div class="public-page__card-header">
            <div class="public-page__card-header-icon">
              <i class="uil uil-user-plus" />
            </div>
            <h2>Crear Cuenta</h2>
            <p>Regístrate y comienza a aprender</p>
          </div>

          <!-- Form -->
          <el-form
            ref="formData"
            v-loading="isFormProcessing"
            :model="formData"
            :rules="rules"
            status-icon
            :label-position="'top'"
            :element-loading-text="formProcessingMessage"
            class="public-page__form"
          >
            <el-form-item
              label="Nombre(s)"
              prop="firstName"
            >
              <el-input
                v-model="formData.firstName"
                placeholder="Ingresa tu nombre(s)"
                size="large"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Apellidos"
              prop="lastName"
            >
              <el-input
                v-model="formData.lastName"
                placeholder="Ingresa tu(s) apellido(s)"
                size="large"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Correo Electrónico"
              prop="email"
            >
              <el-input
                v-model="formData.email"
                type="email"
                placeholder="Ingresa tu correo electrónico"
                size="large"
              >
                <template #prefix>
                  <el-icon><Message /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Contraseña"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                type="password"
                show-password
                placeholder="Crea una contraseña segura"
                size="large"
                @keyup.enter="onSignup('formData')"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Confirmar Contraseña"
              prop="checkPass"
            >
              <el-input
                v-model="formData.checkPass"
                type="password"
                show-password
                placeholder="Confirma tu contraseña"
                size="large"
                @keyup.enter="onSignup('formData')"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <div class="public-page__submit">
              <el-button
                type="primary"
                size="large"
                class="public-page__submit-btn"
                :loading="isFormProcessing"
                @click="onSignup('formData')"
              >
                <i class="uil uil-user-plus" />
                Crear Cuenta
              </el-button>
            </div>
          </el-form>

          <!-- Terms -->
          <div class="public-page__terms">
            Al registrarte, aceptas nuestros
            <a href="/terminos-y-condiciones">Términos de Uso</a> y
            <a href="/terminos-y-condiciones">Políticas de Privacidad</a>.
          </div>

          <!-- Footer -->
          <div class="public-page__card-footer">
            <p>
              ¿Ya tienes una cuenta?
              <router-link to="/login">
                Inicia sesión
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

